<template>
  <div class="login-body">
    <div class="col-12 center-login">
      <div class="modal-dialog">
        <div
          v-if="!showSignupModal && !showResetPasswordModal"
          id="login-content"
          class="modal-content itenter-pop"
          :class="{'shake': isErrorShake}"
        >
          <div class="login-modal text-center">
            <h4 class="modal-title px-2">Էլեկտրոնային հասցեն հաջողությամբ հաստատված է</h4>
          </div>
          <div class="modal-body pt-2">
            <form>
              <span 
                v-if="errorMsgFromApi" 
                class="mb-3 d-block w-100 text-center text-danger" 
              >
                  Հղման ժամկետը լրացել է 
              </span>
              <div class="mb-4 text-primary row justify-content-center">
                <i class="fas fa-check" style="font-size: 84px;"></i>
              </div>
              <div class="row justify-content-center">
                  <a 
                    @click="$router.push('/login')"
                    class="btn btn-primary text-light text-center"
                  >
                    Մուտք գործել
                  </a>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
  @import '@/assets/styles/main.scss';
</style>

<script>
import { required, sameAs, minLength } from 'vuelidate/lib/validators'
export default {
  name: 'EmailConfirm',
  components: {  },
  data () {
    return {
      errorMsgFromApi: '',
    }
  },
  mounted(){
    this.$client.post('user/account/activate', {token: this.$route.params.token}).then((response) => {
      console.log(response)
    })
  },
  methods: {

  },
  validations: {
    fields: {
      password: { required, minLength: minLength(6) },
      password_confirmation: { required, sameAsPassword: sameAs('password') },
    }
  }
}
</script>

<style scoped>
  .shake {
    animation: shake 0.7s cubic-bezier(.36,.07,.19,.97) both;
    transform: translate3d(0, 0, 0);
  }
  @keyframes shake {
    10%, 90% {
      transform: translate3d(-1px, 0, 0);
    }
    20%, 80% {
      transform: translate3d(2px, 0, 0);
    }
    30%, 50%, 70% {
      transform: translate3d(-4px, 0, 0);
    }
    40%, 60% {
      transform: translate3d(4px, 0, 0);
    }
}
</style>
